import { Button, Typography, useTheme } from '@material-ui/core'
import { useState } from 'react'
import { SchoolPersonFragment } from '../../graphql/autogenerate/operations'
import { useInvitePersonToSchoolMutation } from '../../graphql/autogenerate/react-query'
import { useHandleReactQueryMutation } from '../../hooks'
import { useModal } from '../modal'

type Props = {
  modal: ReturnType<typeof useModal>
  schoolPersonToEdit: SchoolPersonFragment
  schoolName: string
}

const SendInvitation = ({ schoolPersonToEdit, schoolName, modal }: Props) => {
  const theme = useTheme()

  const [state, setState] = useState({
    sent: false,
  })

  const { mutate: invitePersonToSchool } = useHandleReactQueryMutation(
    useInvitePersonToSchoolMutation({
      onSuccess: () => setState({ sent: true }),
    })
  )

  if (state.sent) {
    return (
      <div>
        <Typography gutterBottom variant="h6">
          Invitation sent to {schoolPersonToEdit.person?.firstName} at{' '}
          {schoolPersonToEdit.person?.email}.
        </Typography>

        <Typography>
          Tip: it may help to let {schoolPersonToEdit.person?.firstName} know to expect this
          invitation. Consider{' '}
          <a href={`mailto:${schoolPersonToEdit.person?.email}`}>
            sending {schoolPersonToEdit.person?.firstName} an email
          </a>{' '}
          to give them a heads up in case the invitation goes to their junk/spam folder.
        </Typography>

        <Button
          style={{ minWidth: 100, margin: `${theme.spacing(2)}px 0px` }}
          variant="outlined"
          color="primary"
          onClick={modal.close}
        >
          Done
        </Button>
      </div>
    )
  } else {
    return (
      <div>
        <Typography gutterBottom variant="h6">
          No access.
        </Typography>

        <Typography>
          Would you like to send <b>{schoolPersonToEdit.person?.firstName}</b> (
          {schoolPersonToEdit.person?.email}) an invitation to set up their account with{' '}
          {schoolName}?
        </Typography>

        <Button
          variant="contained"
          color="primary"
          style={{ minWidth: 100, margin: `${theme.spacing(2)}px 0px` }}
          onClick={() => {
            invitePersonToSchool({ schoolPersonId: schoolPersonToEdit.id })
          }}
        >
          Send Invitation
        </Button>
      </div>
    )
  }
}

export default SendInvitation
